import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { ContentLayout } from 'components/Layouts'
import { useFetchFullUser } from 'hooks/useFetchFullUser'
import { getMedicareAdvantageStatus } from 'redux/reducers/users'
import { getEMsnPreferences } from 'redux/reducers/claims'
import { MySpinner } from 'components/MySpinner/MySpinner'
import { ClaimsSearchPageContent } from '../components/ClaimsSearchPageContent'
import { cookieInterfaces } from 'utils/cookies'

export const ClaimsSearchPage: FC = () => {
  const { t } = useTranslation('claimsSearch')
  const userLoadingState = useFetchFullUser()
  const isEMsnPreferred =
    useSelector(getEMsnPreferences)?.CMSMSNMediaPreferenceCode === 'E'

  /*
   * isMedicareAdvantage - "Search Anyway"
   */
  const isMedicareAdvantage = useSelector(getMedicareAdvantageStatus)
  const [searchClaimsAnyway, setSearchClaimsAnyway] = useState(() => {
    const showMAContentCookieValue = cookieInterfaces.showMAContent.get()
    return showMAContentCookieValue ? Boolean(showMAContentCookieValue) : false
  })
  const handleSearchAnywayClick = () => {
    cookieInterfaces.showMAContent.set('false')
    setSearchClaimsAnyway(true)
  }

  /*
   * We do not need to handle the error state here. If we fail to retrieve the user, the app will go to /error.
   * If we fail to retrieve emsn preferences we can just assume it's blank
   */
  const isFinished = userLoadingState !== 'loading'
  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      heading={t('myClaimsHeading')}
      width="wide"
      withPrintButton
    >
      {!isFinished && (
        <div className="ds-l-container">
          <MySpinner />
        </div>
      )}
      {isFinished && (
        <ClaimsSearchPageContent
          isEMsnPreferred={isEMsnPreferred}
          displayMAContent={isMedicareAdvantage && !searchClaimsAnyway}
          handleSearchAnywayClick={handleSearchAnywayClick}
        />
      )}
    </ContentLayout>
  )
}
